import {logger} from 'yougile-util'
import {StickerStateId, Tag} from 'yougile-model'

export const reorderStates = (
  from: StickerStateId,
  to: StickerStateId,
  opts: {
    sticker: Tag
    fromOrder: StickerStateId[]
    shouldCommit: boolean
  }
): void => {
  const {sticker, fromOrder, shouldCommit} = opts
  const order = sticker.states.order
  const ixFrom = order.indexOf(from)
  const ixTo = order.indexOf(to)
  if (ixFrom !== fromOrder.indexOf(from) || ixTo !== fromOrder.indexOf(to)) {
    logger.log('incorrect fromOrder')
    return
  }
  if (ixFrom === -1 || ixTo === -1) {
    logger.warn('Sticker reorder: state id not found')
    return
  }
  order.splice(ixFrom, 1)
  order.splice(ixTo, 0, from)
  if (shouldCommit) {
    sticker.commit()
  }
}
